/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import { Timestamp } from '@google-cloud/firestore';
// @ts-ignore
import { MatterFileType } from '../matter';

export enum GlobalFormsKeywords {
	MORTGAGE = 'mortgage',
	GENERIC = 'generic',
}

export interface GlobalGenericFormTemplateLabels {
	formType: string; // This is dynamic, set from adminzer
	matterTypes: MatterFileType[];
}

export interface GlobalMortgageFormTemplateLabels {
	lender: string;
	chargeTypes: string[];
	formType: FormTypes;
	newFlagExpiryDate: Timestamp;
	doesExpiryDateApplyToSync: boolean;
}

export enum FormTypes {
	COVER_SHEET = 'coverSheet',
	REQUEST_FOR_FUNDS = 'requestForFunds',
	FINAL_REPORT = 'finalReport',
	SUPPLEMENTARY = 'supplementary',
	REFERENCE = 'reference',
}

interface BaseGlobalFormTemplate {
	id: string;
	name: string;
	currentVersion: string;
	context: string;
	keywords: Record<string, true>; // always true, because it either exists or it doesn't
}

export interface GlobalMortgageFormTemplate extends BaseGlobalFormTemplate {
	labels: GlobalMortgageFormTemplateLabels;
}

export interface GlobalGenericFormTemplate extends BaseGlobalFormTemplate {
	labels: GlobalGenericFormTemplateLabels;
}

export type GlobalFormTemplate =
	| GlobalMortgageFormTemplate
	| GlobalGenericFormTemplate;

export interface GlobalFormTemplateVersion {
	id: string;
	state: string;
	storageRefPath: string;
	barcodeStorageRefPath: string;
	fieldMappings: FieldMappings;
}

export interface FieldMappings {
	[id: string]: FieldMapping;
}

export interface FieldMapping {
	fieldId: string;
	fieldName: string;
	tag: string; // expression to evaluate
	tagValue: unknown;
	priority: number | null;
}

export interface FormTemplateWithVersion extends GlobalMortgageFormTemplate {
	version: GlobalFormTemplateVersion;
}

export interface FormContext {
	id: string;
	[id: string]: unknown;
}

export interface FormInstance {
	storageRefPath: string;
	barcodeStorageRefPath?: string;
	context: FormContext;
	fields: FieldMappings;
	name: string;
	newFlagExpiryDate?: Date;
	doesExpiryDateApplyToSync?: boolean;
	id: string;
}
